import { render, staticRenderFns } from "./OrdenRestart.vue?vue&type=template&id=5e8625e0&scoped=true&"
import script from "./OrdenRestart.vue?vue&type=script&lang=js&"
export * from "./OrdenRestart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8625e0",
  null
  
)

export default component.exports